import axios from "axios";
import { findPackageById } from "./storePackageUtils";
import { toastifyMessage } from "../../../../../../../../../custom_utilities/toastify_config";

const calculateFinalAmount = (priceDetails) => {
  const coursePrice = Number(priceDetails?.course_price ?? 0);
  const discount = Number(priceDetails?.discount ?? 0);
  return (coursePrice - discount).toFixed(2);
};

const selectPackage = (packageId, packageVariants, setSelectedPackage) => {
  const options = packageVariants?.quick_variants_selection_options;
  if (!options) return;

  const packageFromOptions = findPackageById(
    packageId,
    options,
    packageVariants
  );
  const defaultPackage = packageVariants?.quick_variants_selection_default;

  setSelectedPackage(
    options.length > 0 ? defaultPackage : packageFromOptions || defaultPackage
  );
};

export const fetchPackageData = async ({
  packageId,
  isInitialLoad,
  selectedPackageId,
  initialPackageVariants,
  setPackageData,
  setStoreCurrentPackageDetails,
  setFinalAmount,
  setInitialPackageVariants,
  setSelectedPackage,
  startLoading,
  finishLoading,
}) => {
  try {
    startLoading();

    const response = await axios.get(
      `https://learning.motion.ac.in/motioneducation/api/user/package_detail_web?package_id=${packageId}&platform=website`
    );
    const data = response.data?.data;

    if (!data) {
      throw new Error("No data received from API");
    }

    setPackageData(data);
    setStoreCurrentPackageDetails(data);
    setFinalAmount(calculateFinalAmount(data.price_details));

    if (
      isInitialLoad &&
      packageId === selectedPackageId &&
      !initialPackageVariants
    ) {
      setInitialPackageVariants(data.package_quick_variants);
    }

    selectPackage(packageId, data.package_quick_variants, setSelectedPackage);
  } catch (error) {
    console.error("Error fetching package data:", error.message || error);
    toastifyMessage({
      status: "error",
      message:
        error.message || "Failed to load package details. Please try again.",
    });
  } finally {
    finishLoading();
  }
};

// applyCoupon - Correct discount calculation
export const applyCoupon = async ({
  couponCode,
  userId,
  packageId,
  selectedPackage,
  packageData,
  orderId,
  setFinalAmount,
  setCouponDiscount,
  setAddonDiscount,
  startLoading,
  finishLoading,
  handleCloseCoupon,
  setIsCouponApplied,
  finalAmount, 
}) => {
  if (!couponCode) {
    toastifyMessage({
      status: "error",
      message: "Please enter a coupon code.",
    });
    setCouponDiscount(0);
    setFinalAmount(calculateFinalAmount(packageData?.price_details) || "0.00");
    return;
  }

  if (!userId || !packageId) {
    console.error("Invalid userId or packageId:", { userId, packageId });
    toastifyMessage({
      status: "error",
      message: "Invalid user or package information.",
    });
    setCouponDiscount(0);
    setFinalAmount(calculateFinalAmount(packageData?.price_details) || "0.00");
    return;
  }

  try {
    startLoading();

    const payload = {
      is_coupon: true,
      user_id: userId,
      package_id: packageId,
      order_id: orderId,
      amount: finalAmount,
      coupon_code: couponCode,
    };

    const response = await axios.post(
      "https://learning.motion.ac.in/motioneducation/api/user/apply_couponweb",
      payload
    );

    if (response.data.status === 200 && response.data.data.status === 200) {
      const updatedAmount = Number(response.data.data.updated_amount);

     
      // Previous amount (before this apply) is passed as 'finalAmount'
      const previousAmount = Number(finalAmount || calculateFinalAmount(packageData?.price_details));
      const actualCouponDiscount = Math.max(0, previousAmount - updatedAmount);

      setFinalAmount(updatedAmount.toFixed(2));
      setCouponDiscount(actualCouponDiscount.toFixed(2));
      setAddonDiscount(0);
      setIsCouponApplied(true);

      toastifyMessage({
        status: "success",
        message: response.data.data.message,
      });
      handleCloseCoupon();
    } else {
      // Failed
      setCouponDiscount(0);
      setAddonDiscount(0);
      setFinalAmount(calculateFinalAmount(packageData?.price_details) || "0.00");
      setIsCouponApplied(false);
      toastifyMessage({
        status: "error",
        message: response.data.data.message || response.data.message,
      });
    }
  } catch (error) {
    console.error("Error applying coupon:", error);

    setCouponDiscount(0);
    setAddonDiscount(0);
    setFinalAmount(calculateFinalAmount(packageData?.price_details) || "0.00");
    setIsCouponApplied(false);

    toastifyMessage({
      status: "error",
      message: error.message || "Failed to apply coupon. Please try again.",
    });
  } finally {
    finishLoading();
  }
};